'use client';

import Image from 'next/image';
import { useEffect, useState } from 'react';
import mobileMenuOpenIcon from '@/assets/menu-mobile-open-icon.svg';
import closeIcon from '@/assets/close-icon.svg';
import { LinkGroupStoryblok, StoryblokComponent } from '@/types/types-storyblok';
import clsx from 'clsx';
import { isSelectedSection } from './utils';
import { usePathname } from 'next/navigation';
import { MobileHeaderNavSection } from './mobile/navSection';
import type { StoryblokStory } from 'storyblok-generate-ts';

type MobileHeaderProps = {
  linkGroups: LinkGroupStoryblok[];
  story: StoryblokStory<StoryblokComponent>;
  component: StoryblokComponent;
};

export const MobileHeaderNav = ({ linkGroups: headerSections, story, component }: MobileHeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const pathName = usePathname();

  // close menu on path change
  useEffect(() => {
    setIsOpen(false);
    document.body.style.overflow = '';
  }, [pathName]);

  const toggle = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = !isOpen ? 'hidden' : '';
  };

  return (
    <>
      <button className="relative z-20 xl:hidden" onClick={toggle} aria-controls="mobile-menu" aria-expanded={isOpen}>
        <Image className="h-[22px] w-[22px]" src={isOpen ? closeIcon : mobileMenuOpenIcon} alt="Menu icon" />
      </button>
      <div
        className={clsx(
          'shadow-inset-1 fixed bottom-0 left-0 z-10 flex h-screen-minus-header w-screen flex-col transition-transform duration-300 xl:hidden',
          isOpen ? 'translate-x-0' : 'translate-x-full',
        )}
      >
        <nav id="mobile-menu" aria-hidden={!isOpen} className="flex-grow overflow-y-auto bg-white pb-20 pt-8">
          <ul role="menubar">
            {headerSections.map(section => (
              <MobileHeaderNavSection
                isVisible={isOpen}
                selected={isSelectedSection(pathName as string, section)}
                key={section._uid}
                links={section}
                story={story}
                component={component}
              />
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};
